// extracted by mini-css-extract-plugin
export default {"rowWarning":"SiteTraffic_rowWarning__vS7KG","rowDanger":"SiteTraffic_rowDanger__+gnzO","siteFont":"SiteTraffic_siteFont__JYTBZ"};